module.exports = __webpack_public_path__ + "img/pengyouquan.2932de04.png";